<template>
  <a-modal
    :title="title"

    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :okButtonProps="{ props: {disabled: false} }"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <div class="title">历史上传信息</div>
      <a-table
        :columns="columns"
        :row-key="record => record.id"
        :data-source="uploadHstoryList"
        :pagination="pagination"
        :loading="loading"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleDownload(record)">下载</a>
        </span>
      </a-table>
    </a-spin>
  </a-modal>
</template>

<script>
  import JDate from '@/components/fzis/JDate'
  import JEditor from '@/components/fzis/JEditor'
  import { getAction,downloadFile,putAction,httpAction} from '@api/manage'

  export default {
    components: { JEditor, JDate},
    name: "EnterpriseUploadHistoryModal",
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        labelColX1: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperColX1: {
          xs: { span: 24 },
          sm: { span: 21 },
        },
        confirmLoading: false,
        url: {
          getUploadHistoryList: "/ebid-ce/file/list",
          minioDownload: "/ebid-ce/file/minioDownload"
        },
        msgContent:"",
        pagination: {},
        loading: false,
        uploadHstoryList:[],
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '文件名称',
            align: "center",
            dataIndex: 'fileName'
          },
          {
            title: '文件类型',
            align: "center",
            dataIndex: 'typeZh'
          },
          {
            title: '上传时间',
            align: "center",
            dataIndex: 'createTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            scopedSlots: {customRender: 'action'},
          }
        ],
      }
    },
    created () {

    },
    methods: {
      show (record) {
        this.visible = true;
        this.getUploadHistoryList(record);
      },
      getUploadHistoryList(record){
        this.loading = true;
        var s = this;
        getAction(this.url.getUploadHistoryList,{enterpriseId:record.enterpriseId,type:record.type,delFlag:"0,1"}).then((res) => {
          const pagination = { ...this.pagination };
          pagination.total = res.result.total;

          this.loading = false;
          this.uploadHstoryList = res.result.records;
          this.pagination = pagination;
          console.log("查询成功",res);
        });
      },
      handleDownload(rec) {
        var that = this;
        getAction(that.url.minioDownload,{id: rec.id}).then(res => {
          if(res.success) {
            console.log(res.result);
            downloadFile(res.result , rec.fileName);
          }else{
            that.$message.error(res.message);
          }
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.visible = false;
        this.$emit('close');
      },
      handleCancel () {
        this.visible = false;
        this.$emit('close');
      },
    }
  }
</script>

<style scoped>

</style>